import { connect } from 'react-redux';
import { storeSidebarToggled } from '../../store/layoutOptions';
import UtilityBar from './UtilityBar';

const mapStateToProps = state => ({
  sidebarToggled: state.layoutOptions.sidebarToggled
});

const mapDispatchToProps = dispatch => ({
  setSidebarToggled: toggled => {
    dispatch(storeSidebarToggled(toggled));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(UtilityBar);



// WEBPACK FOOTER //
// ../core/src/components/UtilityBar/index.js